import CustomButton from "../../components/CustomButton";
import CONSTANTS from "../../utils/constants/CONSTANTS";
import { eventTrack, eventTrackGA4 } from "../../utils/helperFunctions";

import "./index.scss";

const WorkoutBanner = ({ mainHeading, workoutImage, mainDescription, description, subDescription }) => {
  const handleClick = () => {
    window.open(CONSTANTS.baseUrl, "_blank");
    eventTrack("Redirection To Web Portal", "From Get started button in programs page", "Redirection");
    eventTrackGA4("Redirection To Web Portal", "From Get started button in programs page", "Redirection");
  };
  return (
    <div className="workout-header">
      <div className="left">
        <div className="title">{mainHeading}</div>
        <div className="description">{mainDescription}</div>
        <div className="description">{description}</div>
        <div className="description">{subDescription}</div>
        <div className="btns">
          <div className="btn">
            <CustomButton type={CONSTANTS.ROUNDED_TYPE} handleClick={handleClick}>
              How it works?
            </CustomButton>
          </div>
          <div className="btn">
            <CustomButton type={CONSTANTS.ROUNDED_TYPE} handleClick={handleClick}>
              Get started
            </CustomButton>
          </div>
        </div>
      </div>
      <div className="right">
        <img className="image" src={workoutImage} alt="workout img" />
      </div>
    </div>
  );
};
export default WorkoutBanner;
